import React from 'react';
import { formatCurrency } from '../../utils/calculations';
interface TotalsPanelProps {
  subtotal: number;
  taxAmount: number;
  taxRate: number;
  shippingCharge?: number;
  discount?: number;
  total: number;
}
export function TotalsPanel({
  subtotal,
  taxAmount,
  taxRate,
  shippingCharge = 0,
  discount = 0,
  total
}: TotalsPanelProps) {
  return <div className="bg-gray-50 rounded-lg p-4 space-y-2" data-id="element-95">
      <div className="flex justify-between text-sm" data-id="element-96">
        <span className="text-gray-600" data-id="element-97">Subtotal</span>
        <span className="font-medium text-gray-900" data-id="element-98">
          {formatCurrency(subtotal)}
        </span>
      </div>

      {shippingCharge > 0 && <div className="flex justify-between text-sm" data-id="element-99">
          <span className="text-gray-600" data-id="element-100">Shipping</span>
          <span className="font-medium text-gray-900" data-id="element-101">
            {formatCurrency(shippingCharge)}
          </span>
        </div>}

      <div className="flex justify-between text-sm" data-id="element-102">
        <span className="text-gray-600" data-id="element-103">
          Tax ({(taxRate * 100).toFixed(0)}%)
        </span>
        <span className="font-medium text-gray-900" data-id="element-104">
          {formatCurrency(taxAmount)}
        </span>
      </div>

      {discount > 0 && <div className="flex justify-between text-sm" data-id="element-105">
          <span className="text-gray-600" data-id="element-106">Discount</span>
          <span className="font-medium text-green-600" data-id="element-107">
            -{formatCurrency(discount)}
          </span>
        </div>}

      <div className="border-t border-gray-200 pt-2 mt-2" data-id="element-108">
        <div className="flex justify-between" data-id="element-109">
          <span className="text-base font-semibold text-gray-900" data-id="element-110">Total</span>
          <span className="text-base font-bold text-gray-900" data-id="element-111">
            {formatCurrency(total)}
          </span>
        </div>
      </div>
    </div>;
}